import StandardNavigation from "@components/navigation/StandardNavigation";
import { Box, Container } from "@material-ui/core";

export default function Wrapper(props: { children: React.ReactChild | React.ReactChild[] }) {
  return (
    <StandardNavigation>
      <Box py={5}>
        <Container maxWidth="lg">
          {props.children}
        </Container>
      </Box>
    </StandardNavigation>
  );
}
